import { render } from "./AboutTwoPage.vue?vue&type=template&id=0048871e&ts=true"
import script from "./AboutTwoPage.vue?vue&type=script&lang=ts"
export * from "./AboutTwoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__